module.exports = __webpack_public_path__ + "static/media/fundef-fundeb.055e6797.webp";